// @flow
import TariffInfo from './TariffInfo';

export default TariffInfo;
